import React from 'react';
import {
  convertAssessmentQualityStateScoring,
  convertAssessmentQualityStateForTraining,
} from './Helpers/functionsHelpers';
import { MenuItem } from '@material-ui/core';
import { useStyles } from './AssessmentQualityDropDownMenuFilters.styles';
import { AssessmentSessionProcessTypeId } from '../../services/exams/assessmentSession/assessments.types';
import Checkbox from '../../components/Checkbox.component';
interface AssessmentQualityDropDownMenuFilters<T> {
  menuItems: string[];
  hasCheckbox?: boolean;
  checkedItems: string[];
  onChange: (item: T) => void;
  uncheckAllMenuItems: () => void;
  processType: AssessmentSessionProcessTypeId;
}
interface QualityAssessmentMenuItems {
  name: string;
  value: string;
}
const AssessmentQualityDropDownMenuFilters: React.FC<AssessmentQualityDropDownMenuFilters<string>> = (props) => {
  const classes = useStyles();

  type Predicate<T> = (item: T) => boolean;

  const createFilter = (processType: AssessmentSessionProcessTypeId): Predicate<string> => {
    if (processType === AssessmentSessionProcessTypeId.Training) {
      return (item: string) => item !== 'Ocena poza zakresem tolerancji';
    } else {
      return () => true;
    }
  };

  const mapQualityAssessmentMenuItem = (
    item: string,
    processType: AssessmentSessionProcessTypeId,
  ): QualityAssessmentMenuItems => {
    if (processType === AssessmentSessionProcessTypeId.Training) {
      return {
        name: item,
        value: convertAssessmentQualityStateForTraining(item),
      };
    } else if (processType === AssessmentSessionProcessTypeId.Qualification) {
      return {
        name: item.includes('Wystąpiły rozbieżności w ocenie') ? 'Ocena w zakresie tolerancji' : item,
        value: convertAssessmentQualityStateScoring(item),
      };
    } else {
      return {
        name: item,
        value: convertAssessmentQualityStateScoring(item),
      };
    }
  };

  const finalMenuItems: QualityAssessmentMenuItems[] = props.menuItems
    .filter(createFilter(props.processType))
    .map((item: string) => mapQualityAssessmentMenuItem(item, props.processType));

  return (
    <>
      {finalMenuItems.length > 0 &&
        finalMenuItems.map((item: QualityAssessmentMenuItems) => {
          const label: string = item.name;
          const value: string = item.value;
          return (
            <MenuItem
              disableRipple
              key={label}
              tabIndex={0}
              onKeyDown={(event) => {
                if (event.key === 'Enter') {
                  props.onChange(value);
                }
              }}
              style={{ cursor: 'pointer' }}
              onClick={(event) => {
                event.preventDefault();
                props.onChange(value);
              }}
              aria-controls="menu"
              aria-checked={props.checkedItems.indexOf(value) !== -1}
              role="menuitemcheckbox"
            >
              {props.hasCheckbox && (
                <Checkbox
                  className={classes.filterMenuCheckbox}
                  checked={props.checkedItems.indexOf(value) !== -1}
                  onChange={() => props.onChange(value)}
                />
              )}
              {label}
            </MenuItem>
          );
        })}
    </>
  );
};

export default AssessmentQualityDropDownMenuFilters;
